<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <b-table class="table mb-0 table-responsive" hover responsive="sm"
                       :items="filterOn" :fields="headerTable"
                       :per-page="10" :current-page="currentPage">
                <!-- A custom Type column -->
                <template #cell(id)="element">
                  <td v-if="element.item.id">
                    {{ element.item.id }}
                  </td>
                  <td v-else class="text-muted-color ">Aucune données</td>
                </template>
                <template #cell(folder)="element">
                  <td v-if="element.item.hasOwnProperty('req')&& element.item.req.s_type_bien && element.item.req.s_usage_bien"
                      class="title-width">
                    {{
                      demandTypeStatus(element.item.req.s_type_bien) + ' ' + useStatus(element.item.req.s_usage_bien) | truncate(51, " ...")
                    }}
                  </td>
                  <td v-else-if="getIsLoadingTitle">
                    <b-spinner small label="Small Spinner" variant="success"></b-spinner>
                  </td>
                  <td v-else class="text-muted-color ">Aucune données</td>
                </template>
                <template #cell(dateE)="element">
                  <td v-if="element.item.createdAt">{{ formatDate(element.item.createdAt) }}</td>
                  <td v-else class="text-muted-color">Aucune données</td>
                </template>
                <template #cell(dateL)="element">
                  <td v-if="element.item.validUntil">
                    {{ formatDate(element.item.validUntil) }}
                  </td>
                  <td v-else class="text-muted-color w-auto">Aucune données</td>
                </template>
                <template #cell(state)="element">
                  <span v-if="statusData(element.item.status, dataState)"
                        class="badge  font-size-11 "
                        :class="statusData(element.item.status, dataState).class"
                  >{{ statusData(element.item.status, dataState).name }}</span>
                  <span
                      v-else-if="element.item.drafts && !element.item.status && element.item.validUntil > nowDate"
                      class="badge bg-light font-size-11">Brouillon</span>
                  <span
                      v-else-if="!element.item.drafts && !element.item.status && element.item.validUntil > nowDate"
                      class="badge badge-soft-info font-size-11">Envoyée</span>

                  <span v-else-if="nowDate > element.item.validUntil" class="badge badge-soft-danger font-size-11">Expiré</span>
                </template>
                <template #cell(action)="element">
                  <td>
                    <ul class="list-inline font-size-20 contact-links mb-0 "
                        v-if="!element.item.drafts && element.item.hasOwnProperty('req')">
                      <li class="list-inline-item">
                        <a @click="redirectionPropsition(element.item.id)" size="sm">
                          <i v-b-tooltip.hover
                             title="Modifier" class="fas fa-eye px-2 pointer color-edit float-end"></i>
                        </a>
                      </li>
                    </ul>
                    <ul class="list-inline font-size-20 contact-links mb-0 d-flex" v-else>
                      <li class="list-inline-item" v-if="element.item.hasOwnProperty('req') ">
                        <a :href="'/proposals/' + element.item.id + '/edit'">
                          <i
                              v-b-tooltip.hover
                              title="Modifier"
                              class="bx bx-edit-alt pointer color-edit float-end"
                          >
                          </i>
                        </a>
                      </li>
                      <li class="list-inline-item px-2">
                        <i v-b-tooltip.hover
                           title="Supprimer"
                           class="bx bx-trash-alt pointer color-delete float-end"
                           @click="confirmDelete(element.item)"
                        >
                        </i>
                      </li>
                    </ul>
                  </td>
                </template>
              </b-table>
              <div v-if="Loading" class="mt-2 mb-2">
                <b-spinner small label="Small Spinner" variant="success"></b-spinner>
              </div>
            </div>
            <!-- Pagination -->
            <Pagination
                @changePage="onPaginate($event)"
                :page="currentPage" :itemsPerPage="10" :listLength="proposals.total_count"
            />
            <div class="mt-4" v-show="!Loading">
              <b-alert show variant="danger"
                       v-show="!Loading && filterKeyword.length !== 0 && filterOn.length === 0 || proposals.total_count === 0 && !Loading">
                <i class="mdi mdi-block-helper me-2"></i>Vous n’avez <strong>aucune </strong> proposition
              </b-alert>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {dataState} from "@/router/views/proposals/statusData";
import Pagination from "@/components/pagination";
import {titlesHeaderProposalsModelMy} from "@/router/views/titlesHeaderModel";

/**
 *
 */
export default {
  page: {
    title: "Mes propositions",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {Layout, PageHeader, Pagination},
  data() {
    return {
      title: "Mes propositions",
      items: [],
      currentPage: 1,
      filterOn: [],
      filterKeyword: "",
      headerTable: titlesHeaderProposalsModelMy,
      nowDate: new Date().toLocaleDateString('en-CA'),
      cp: 0,
    };
  },
  created() {
    this.getList();
    this.dataState = dataState;
  },
  methods: {
    // Get list of proposals
    getList() {
      this.$store.dispatch("proposals/proposalsList", this.currentPage);
    },
    /*confirm delete */
    confirmDelete(element) {
      this.showAlert({
        title: "Vous êtes sûr ?",
        text: "Vous ne pourrez pas revenir en arrière !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b1215c",
        confirmButtonText: "Oui, supprimez-le !",
        cancelButtonText: "Annuler",
        confirmType: {
          type: "deleteProposal",
          id: element.id,
        },
      });
    },
    /* delete Proposal  */
    deleteProposal(id) {
      this.$store.dispatch("proposals/deleteProposal", id).then(
          (res) => {
            this.showAlert({
              icon: "success",
              title: "Supprimé!",
              text: "Cette proposition a été supprimée avec succès",
              confirmType: {
                type: "getList",
              },
            });
            this.getList();
          },
          (err) => {
            this.showAlert({
              icon: "error",
              title: "Non supprimé!",
              text: "Echec de suppression",
            });
          }
      );
    },
    /* Alerts */
    showAlert(data) {
      Swal.fire({
        icon: data.icon,
        title: data.title,
        text: data.text,
        confirmButtonColor: "#b1215c",
        showCancelButton: data.showCancelButton,
        confirmButtonText: data.confirmButtonText
            ? data.confirmButtonText
            : "OK",
        cancelButtonText: data.cancelButtonText,
      }).then((res) => {
        if (data.confirmType) {
          if (data.confirmType.type === "deleteProposal") {
            if (res.isConfirmed) this.deleteProposal(data.confirmType.id);
          }
        }
      });
    },
    /*match data */
    matchData(data) {
      let displayData = [];
      for (let i = 1; i <= this.currentPage; i++) {
        if (i === this.currentPage) {
          displayData = [...displayData, ...data.items];
        } else {
          for (let j = 1; j <= 10; j++) {
            displayData.push({});
          }
        }
      }
      this.filterOn = displayData;
    },
    /* */
    redirectionPropsition(root) {
      this.$root.$router.push({
        path: '/proposals/' + root,
        query: {name: 'proposals'}
      })
    },
    /* change page */
    onPaginate(event) {
      this.currentPage = event;
      this.getList();
    },
  },
  computed: {
    // Get proposals data from store
    proposals() {
      let proposals = this.$store.getters["proposals/getList"];
      if (proposals) {
        this.matchData(proposals);
      }
      return proposals;
    },
    Loading() {
      return this.$store.getters["proposals/getIsLoading"];
    },
    getIsLoadingTitle() {
      return this.$store.getters["proposals/getIsLoadingTitle"];
    },
  },
  filters: {
    truncate: function (text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    },
  },
};
</script>

<style scoped lang="scss">

::v-deep thead {
  color: #000000;
  border-color: #eff2f7;
  background-color: #eff2f7;
}
</style>